var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\n      .cls-2 {\n        fill: #bfbfbf;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.064,8.979 C15.064,8.979 9.041,9.036 9.041,9.036 C9.041,9.036 9.098,15.058 9.098,15.058 C9.104,15.708 8.767,16.036 8.088,16.042 C7.409,16.048 7.067,15.727 7.060,15.078 C7.060,15.078 7.004,9.055 7.004,9.055 C7.004,9.055 0.981,9.111 0.981,9.111 C0.332,9.117 0.004,8.781 -0.002,8.102 C-0.009,7.423 0.313,7.080 0.962,7.074 C0.962,7.074 6.985,7.018 6.985,7.018 C6.985,7.018 6.929,0.995 6.929,0.995 C6.922,0.345 7.259,0.017 7.938,0.011 C8.617,0.005 8.959,0.326 8.966,0.976 C8.966,0.976 9.022,6.998 9.022,6.998 C9.022,6.998 15.045,6.942 15.045,6.942 C15.694,6.936 16.022,7.272 16.029,7.951 C16.035,8.631 15.713,8.973 15.064,8.979 Z",
    id: "path-1",
    className: "cls-2",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.25203093.svg";
export { ForwardRef as ReactComponent };